/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_NavInputs */

const vi_media_nav = /** @type {(inputs: Media_NavInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thư viện ảnh`)
};

/**

* @param {Media_NavInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const media_nav = /** @type {((inputs?: Media_NavInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_NavInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_media_nav(inputs)
});